import { RootState } from '../store';

export const selectExtensionInfo = (state: RootState) => state.extensionInfo;
